import React, { useState, useEffect } from 'react';
import './App.css';
import Hello from './components/Hello';
import Apple from './components/Apple';
import Rossetti from './components/Rossetti';
import Pane from './components/Pane';
import Wine from './components/Wine';
import Futbol from './components/Futbol';
import Jeep from './components/Jeep';
import Genes from './components/Genes';
import Calendar from './components/Calendar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PerformanceMonitor from './components/PerformanceMonitor';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hello');

  // Close mobile menu when clicking on a link
  const handleNavClick = (sectionId) => {
    setIsMobileMenuOpen(false);
    setActiveSection(sectionId);
    // Re-enable body scroll
    document.body.classList.remove('mobile-menu-open');
  };

  // Toggle mobile menu and body scroll
  const toggleMobileMenu = () => {
    const newState = !isMobileMenuOpen;
    setIsMobileMenuOpen(newState);
    
    // Toggle body scroll lock
    if (newState) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  };

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.navbar')) {
        setIsMobileMenuOpen(false);
        document.body.classList.remove('mobile-menu-open');
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobileMenuOpen]);

  // Clean up body class on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, []);

  // Track active section based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hello', 'apple', 'pane', 'wine', 'futbol', 'jeep', 'genes', 'rossetti', 'calendar'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {/* Performance monitoring in development */}
      {process.env.NODE_ENV === 'development' && <PerformanceMonitor />}
      
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-brand">
            <span>MarcoDeMarco.net</span>
          </div>
          
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <ul className={`navbar-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <li>
              <a 
                href="#hello" 
                className={activeSection === 'hello' ? 'active' : ''}
                onClick={() => handleNavClick('hello')}
              >
                <img src="/images/hello.png" alt="Hello" className="nav-icon" />
                Ciao
              </a>
            </li>
            <li>
              <a 
                href="#apple" 
                className={activeSection === 'apple' ? 'active' : ''}
                onClick={() => handleNavClick('apple')}
              >
                <img src="/images/apple.png" alt="Apple" className="nav-icon" />
                06489
              </a>
            </li>
            <li>
              <a 
                href="#pane" 
                className={activeSection === 'pane' ? 'active' : ''}
                onClick={() => handleNavClick('pane')}
              >
                <img src="/images/pane.png" alt="Pane" className="nav-icon" />
                Pane
              </a>
            </li>
            <li>
              <a 
                href="#wine" 
                className={activeSection === 'wine' ? 'active' : ''}
                onClick={() => handleNavClick('wine')}
              >
                <img src="/images/wine.png" alt="Wine" className="nav-icon" />
                Vino
              </a>
            </li>
            <li>
              <a 
                href="#futbol" 
                className={activeSection === 'futbol' ? 'active' : ''}
                onClick={() => handleNavClick('futbol')}
              >
                <img src="/images/futbol.png" alt="Futbol" className="nav-icon" />
                Futbol
              </a>
            </li>
            <li>
              <a 
                href="#jeep" 
                className={activeSection === 'jeep' ? 'active' : ''}
                onClick={() => handleNavClick('jeep')}
              >
                <img src="/images/jeep.png" alt="Jeep" className="nav-icon" />
                Jeep
              </a>
            </li>
            <li>
              <a 
                href="#genes" 
                className={activeSection === 'genes' ? 'active' : ''}
                onClick={() => handleNavClick('genes')}
              >
                <img src="/images/genes.svg" alt="Gene's" className="nav-icon" />
                Gene's
              </a>
            </li>
            <li>
              <a 
                href="#rossetti" 
                className={activeSection === 'rossetti' ? 'active' : ''}
                onClick={() => handleNavClick('rossetti')}
              >
                <img src="/images/rossetti.png" alt="Rossetti" className="nav-icon" />
                Rossetti
              </a>
            </li>
            <li>
              <a 
                href="#calendar" 
                className={activeSection === 'calendar' ? 'active' : ''}
                onClick={() => handleNavClick('calendar')}
              >
                <img src="/images/calendar.png" alt="Calendar" className="nav-icon" />
                Calendar
              </a>
            </li>
          </ul>
        </div>
      </nav>
      
      <main>
        <Hello />
        <Apple />
        <Pane />
        <Wine />
        <Futbol />
        <Jeep />
        <Genes />
        <Rossetti />
        <Calendar />
      </main>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;
